import { css as _css } from "@emotion/react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import Ansi from 'ansi-to-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VariableSizeList as List } from 'react-window';
import IconRefresh from '~icons/ci/refresh';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { theme, typography } from '@arc/frontend/ui-theme';
import { logBodyPadding, styles } from './styles';
const topRowPadding = logBodyPadding;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "pmnpn6",
  styles: "height:20px;width:20px"
} : {
  name: "gtyv0t-LogsView",
  styles: "height:20px;width:20px;label:LogsView;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function LogsView({
  logs,
  refetchData,
  emptyLogsText = 'Waiting for logs...',
  showLoadingIndicator = false
}) {
  const {
    t
  } = useTranslation('builds');
  const [tail, setTail] = useState(true);
  const [containerHeight, setContainerHeight] = useState(0);
  const containerRef = useRef(null);
  const [listRef, setListRef] = useState(null);
  useEffect(() => {
    if (containerRef.current) {
      const {
        height
      } = containerRef.current.getBoundingClientRect();
      setContainerHeight(height);
    }
  }, []);
  useEffect(() => {
    if (tail && listRef) {
      listRef.scrollToItem(logs.length - 1, 'end');
    }
  }, [listRef, logs, tail]);
  function Row({
    index,
    style
  }) {
    const log = logs[index];
    if (!log) return null;
    return <div css={[styles.logLine, process.env.NODE_ENV === "production" ? "" : ";label:Row;"]} style={{
      ...style,
      color: lineColor(log.message),
      paddingTop: index === 0 ? topRowPadding : '0'
    }}>
				{index + 1} | {log.timestamp} | <Ansi>{log.message}</Ansi>
			</div>;
  }
  return <div css={styles.container}>
			<div css={styles.header}>
				<h2 css={[typography.subTitle, "display:flex;align-items:center;gap:8px;" + (process.env.NODE_ENV === "production" ? "" : ";label:LogsView;")]}>
					<IconRefresh onClick={() => refetchData()} css={/*#__PURE__*/_css({
          cursor: 'pointer',
          color: theme.colors.palettes.primary.main,
          width: '20px',
          height: '20px'
        }, process.env.NODE_ENV === "production" ? "" : ";label:LogsView;")} />
					{t('Logs')}
					{showLoadingIndicator ? <LoadingIndicator immediate css={_ref} /> : null}
				</h2>
				<button onClick={() => setTail(prev => !prev)} css={styles.tailButton} type="button">
					{tail ? 'Tail: ON' : 'Tail: OFF'}
				</button>
			</div>

			<div css={styles.logsContainer} ref={containerRef}>
				{logs.length > 0 && containerHeight > 0 ? <List height={containerHeight} itemCount={logs.length} itemSize={calculateLogRowHeight(logs)} width="100%" ref={setListRef} css={styles.logsBody}>
						{Row}
					</List> : <div css={/*#__PURE__*/_css({
        padding: logBodyPadding
      }, process.env.NODE_ENV === "production" ? "" : ";label:LogsView;")}>{t(emptyLogsText)}</div>}
			</div>
		</div>;
}

/*
	We're simply assuming that each log message could have multiple lines,
	and we calculate the height based on the number of lines.
	Assuming an average line height of 25px, we multiply the number of lines by this value.
	for example, if a message has 10 lines, height = 10 * 25 = 250px.
	If the calculated height is less than 36px, we return 36px as the minimum height.
*/
function calculateLogRowHeight(logs) {
  return index => {
    const message = logs[index]?.message;
    const lines = message?.split('\n').length ?? 0;
    const averageLineHeight = 23;
    const messageLineHeight = Math.max(lines * averageLineHeight, 25);
    return index === 0 ? messageLineHeight + topRowPadding : messageLineHeight;
  };
}
function lineColor(line) {
  if (line.includes('ERROR')) return '#f44747';else if (line.includes('WARN')) return '#ffaf00';else if (line.includes('INFO')) return '#4fc1ff';else if (line.includes('SUCCESS')) return '#4ec9b0';
  return '#d4d4d4';
}